import React, { useState } from 'react';
import PropTypes from 'prop-types';

import hintStyle from './hint.module.css';

const BODY_WIDTH_MOBILE = 290;
const BODY_WIDTH_TABLET = 470;
const LAYOUT_WIDTH_DESKTOP = 1170;
const TABLET_WIDTH = 768;
const DESKTOP_WIDTH = 1440

const Hint = (props) => {
  const hint = React.createRef();

  const [show, setShow] = useState(false);
  const [left, setLeft] = useState(0);

  const handleClick = () => {
    if ((hint.current.offsetLeft > 15 && document.documentElement.clientWidth < TABLET_WIDTH)
      || (document.documentElement.clientWidth - BODY_WIDTH_TABLET - hint.current.offsetLeft < 0)
    ) {
      const position = (document.documentElement.clientWidth - BODY_WIDTH_MOBILE) / 2 - hint.current.offsetLeft;
      setLeft(position);
    }

    // для десктопа проверяем позицию справа
    if (document.documentElement.clientWidth >= DESKTOP_WIDTH && (document.documentElement.clientWidth - LAYOUT_WIDTH_DESKTOP) / 2 + LAYOUT_WIDTH_DESKTOP < hint.current.offsetLeft + BODY_WIDTH_TABLET) {
      const position = -(hint.current.offsetLeft + BODY_WIDTH_TABLET - (document.documentElement.clientWidth - LAYOUT_WIDTH_DESKTOP) / 2 - LAYOUT_WIDTH_DESKTOP);
      setLeft(position);
    }

    setShow(!show);
  }

  const handleBackdropClick = () => {
    setShow(false);
  }

  return (
    <div className={hintStyle.hint} ref={hint}>
      <span className={hintStyle.pinkText} onClick={handleClick}> {props.children}</span>

      {show && (
        <React.Fragment>
          <div className={hintStyle.backdrop} onClick={handleBackdropClick} />
          <div className={hintStyle.hintTriangle} onClick={handleBackdropClick} />
          <div className={hintStyle.hintBody} style={{ left }} onClick={handleBackdropClick}>
            {props.definition}
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

Hint.propTypes = {
  children:  PropTypes.node,
  definition: PropTypes.string,
}

Hint.defaultProps = {
  children:  null,
  definition: '',
}

export default Hint;
